<app-base-layer-select *ngIf="layers" [layers]="layers"></app-base-layer-select>
<app-overlay-group-select *ngIf="layers" [layers]="layers.getOverlayLayers()"></app-overlay-group-select>
